import { AppConfig } from '@mkp/shared/util-app-config';
const { routes } = AppConfig;

export const isApplicationUrl = (url: string): boolean =>
  !!url.match(new RegExp(`${routes.vacancy}/[^/]+/${routes.applications}`));
